/**
 * 拓扑插件-图形类型名称常量定义
 */
export default {
  // 矩形
  rect: 'rect',
  // 圆形
  circle: 'circle',
  // 椭圆
  ellipse: 'ellipse',
  // 三角形
  triangle: 'triangle',
  // 菱形
  diamond: 'diamond',
  // 星形
  star: 'star',
  // 图片
  image: 'image',
  // 卡片
  modelRect: 'modelRect',
  // 空心圆形
  donut: 'donut',
  // 文字
  text: 'text',
  // 分组
  group: 'Group',
  // 字体图标
  iconFont: 'iconFont',
  // 扩展图片
  customImage: 'customImage',

  // 边-直线条
  line: 'Line',
  // 边-有两个控制点的曲线
  cubic: 'cubic',
  // 曲线圆形动画
  cubicCircleRunning: 'cubic_circle_running',
  // 边-有一个控制点的曲线
  quadratic: 'quadratic',
  // 单弧度曲线圆形动画
  quadraticCircleRunning: 'quadratic_circle_running',
  // 单弧度曲线虚线动画
  quadraticDashRunning: 'quadratic_dash_running',
  // 单弧度曲线断线重连动画
  quadraticGrowthRunning: 'quadratic_growth_running',
  // 单直线图片水滴动画
  lineLiquidFillRunning: 'line_liquid_fill_running',





  // 动画
  animation: 'Animation',
  // 弧形
  arc: 'Arc',
  // 箭头
  arrow: 'Arrow',
  // 画布
  canvas: 'Canvas',

  container: 'Container',
  context: 'Context',

  fastLayer: 'FastLayer',


  // 标签
  label: 'Label',
  // 图层
  layer: 'Layer',

  node: 'Node',
  // 路径
  path: 'Path',

  // 等边多边形
  regularPolygon: 'RegularPolygon',
  // 环形
  ring: 'Ring',
  // 形状？
  shape: 'Shape',
  // 精灵图
  sprite: 'Sprite',
  // 舞台（画布）
  stage: 'Stage',

  tag: 'Tag',

  // 路径文字
  textPath: 'TextPath',
  transform: 'Transform',
  transformer: 'Transformer',
  tween: 'Tween',
  // 扇形
  wedge: 'Wedge'

};
